import { useCallback } from 'react';

const SCROLL_THRESHOLD = 50;

interface UseInfiniteScrollProps {
  onFetchMore?: () => void;
  hasMore?: boolean;
  isLoading?: boolean;
  isFetching?: boolean;
}

export const useInfiniteScroll = ({
  onFetchMore,
  hasMore = false,
  isLoading = false,
  isFetching = false,
}: UseInfiniteScrollProps) => {
  const handleScroll = useCallback(
    (event: React.UIEvent<HTMLElement>) => {
      if (!onFetchMore || !hasMore || isLoading || isFetching) {
        return;
      }

      const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
      if (scrollHeight - (scrollTop + clientHeight) < SCROLL_THRESHOLD) {
        onFetchMore();
      }
    },
    [onFetchMore, hasMore, isLoading, isFetching]
  );

  return { handleScroll };
};
